module.exports = __webpack_public_path__ + "img/logo_ko_bob_black.2d1bbac1.svg";